import styled, {css} from "styled-components";

interface ILiveCasinoGridItemDefaultBoxProps {
    fluidWidth?: boolean; // when true, don't set the width, let it flow within its parent
}

export const LiveCasinoGridItemDefaultBox = styled.div<ILiveCasinoGridItemDefaultBoxProps>`
    box-sizing: border-box;

    /* Prevents CSS Transform flicker */
    backface-visibility: hidden;

    ${({fluidWidth}) => !fluidWidth && css`

        width: calc(100% / 5);
        padding: 1em 0.5em;

        @media ${({theme}) => theme.mediaQuery.mAndAbove} {
        width: calc(100% / 3);
        }
        @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
        width: calc(100% / 4);
        }
        @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        width: calc(100% / 2);
        padding: 0.5em 0.25em;
        }
    `}
`;